

export const escapeHtmlEntities = (str) => {
  var map = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    "\"": "&quot;",
    "'": "&#39;" // ' -> &apos; for XML only
  };
  return str.replace(/[&<>"']/g, function (m) { return map[m]; });
};
export const unescapeHtmlEntities = (str) => {
  var map = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": "\"",
    "&#39;": "'",
    "&apos;": "'"
  };
  return str.replace(/(&amp;|&lt;|&gt;|&quot;|&#39;|&apos;)/g, function (m) { return map[m]; });
};

export const desanitize = (object) => {
  if (typeof (object) === 'string') return unescapeHtmlEntities(object);
  if (typeof (object) === 'object' && object !== null) {
    if (Array.isArray(object)) {
      for (let i = 0; i < object.length; i++) {
        object[i] = desanitize(object[i]);
      }
    } else {
      let keys = Object.keys(object);
      for (let i = 0; i < keys.length; i++) {
        object[keys[i]] = desanitize(object[keys[i]]);
      }
    }
  }
  return object;
}
